// Subtle drifting starfield.
// Small dots crossing slowly from left to right with a gentle twinkle — meant to
// sit UNDER the artwork, not compete with it. No streaks, no trails: the
// backdrop photo has to stay readable through it.
(function () {
  var canvases = document.querySelectorAll('[data-stardrift]');
  if (!canvases.length) return;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function num(el, key, fallback) {
    var v = parseFloat(el.dataset[key]);
    return isNaN(v) ? fallback : v;
  }

  canvases.forEach(function (canvas) {
    // Two sections each ship their own <script src="stardrift.js">, and a second
    // tag with the same URL executes again — without this guard every canvas got
    // two rAF loops, each clearing the other's frame.
    if (canvas.dataset.driftReady) return;
    canvas.dataset.driftReady = '1';

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var cfg = {
      count: Math.max(1, num(canvas, 'count', 150)),
      speed: num(canvas, 'speed', 14) / 10,        // px/sec at the nearest depth
      size: num(canvas, 'size', 12) / 10,          // radius multiplier
      opacity: Math.min(1, num(canvas, 'opacity', 55) / 100),
      twinkle: num(canvas, 'twinkle', 4) / 10,
      shoot: num(canvas, 'shoot', 5),              // seconds between shooting stars, 0 = off
      dir: canvas.dataset.dir === 'left' ? -1 : 1
    };
    var tint = canvas.dataset.color || '#ffffff';

    var stars = [];
    var w = 0, h = 0, raf = null, lastT = 0;

    function seed(s, spread) {
      s.x = spread ? Math.random() * w : (cfg.dir > 0 ? -4 : w + 4);
      s.y = Math.random() * h;
      // depth drives size, speed and brightness together, so far stars read as
      // far rather than just small
      s.z = Math.random();
      s.r = (0.35 + s.z * 1.15) * cfg.size;
      s.v = (4 + s.z * 16) * cfg.speed;
      s.a = (0.16 + s.z * 0.7) * cfg.opacity;
      s.ph = Math.random() * Math.PI * 2;
      s.tw = 1.2 + Math.random() * 2.4;   // rad/sec — slower than this reads as static
      // only about a third of the field blinks — a sky where every star pulses
      // reads as noise rather than as stars
      s.blinks = Math.random() < 0.35;
    }

    function build() {
      stars.length = 0;
      for (var i = 0; i < cfg.count; i++) { var s = {}; seed(s, true); stars.push(s); }
    }

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var rect = canvas.getBoundingClientRect();
      var nw = Math.max(1, Math.floor(rect.width) || 600);
      var nh = Math.max(1, Math.floor(rect.height) || 400);
      if (nw === w && nh === h) return;
      w = nw; h = nh;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      build();
    }

    // ---- shooting star ----
    // One at a time, upper-left to lower-right, crossing only part of the frame:
    // enough to read as a direction, not a line drawn corner to corner.
    var shot = null;
    var nextShot = cfg.shoot ? cfg.shoot * (0.5 + Math.random()) : Infinity;

    function launch() {
      var diag = Math.sqrt(w * w + h * h);
      var travel = diag * (0.22 + Math.random() * 0.18);
      var ang = (26 + Math.random() * 16) * Math.PI / 180;   // downward-right
      shot = {
        x: w * (0.04 + Math.random() * 0.4),
        y: h * (Math.random() * 0.34),
        vx: Math.cos(ang), vy: Math.sin(ang),
        len: 60 + Math.random() * 90,
        travel: travel, gone: 0,
        speed: travel / (0.9 + Math.random() * 0.5)
      };
    }

    function drawShot(dt) {
      if (!shot) return;
      shot.gone += shot.speed * dt;
      var p = shot.gone / shot.travel;
      if (p >= 1) { shot = null; return; }
      var x = shot.x + shot.vx * shot.gone;
      var y = shot.y + shot.vy * shot.gone;
      // in over the first tenth, out over the last third
      var a = Math.min(1, p / 0.1) * Math.min(1, (1 - p) / 0.34) * 0.85 * cfg.opacity;
      var tx = x - shot.vx * shot.len;
      var ty = y - shot.vy * shot.len;
      var grad = ctx.createLinearGradient(tx, ty, x, y);
      grad.addColorStop(0, 'rgba(255,255,255,0)');
      grad.addColorStop(1, tint);
      ctx.globalAlpha = a;
      ctx.strokeStyle = grad;
      ctx.lineWidth = 1.4;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(tx, ty);
      ctx.lineTo(x, y);
      ctx.stroke();
      ctx.globalAlpha = 1;
    }

    function frame(dt, t) {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = tint;
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.x += s.v * dt * cfg.dir;
        if (cfg.dir > 0 ? s.x > w + 4 : s.x < -4) { seed(s, false); continue; }
        // twinkle rides on the base alpha instead of replacing it, so a star
        // never blinks fully out
        // At the old depth (×0.5) a twinkle of 4 moved alpha by 20% of an already
        // faint dot — invisible. Full setting now takes a star most of the way down.
        var tw = (s.blinks && cfg.twinkle > 0)
          ? 1 - cfg.twinkle * 0.85 * (1 + Math.sin(t * s.tw + s.ph)) / 2
          : 1;
        ctx.globalAlpha = Math.max(0, s.a * tw);
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, 6.2832);
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      if (!shot && cfg.shoot > 0) {
        nextShot -= dt;
        if (nextShot <= 0) { launch(); nextShot = cfg.shoot * (0.7 + Math.random() * 0.6); }
      }
      drawShot(dt);
    }

    function loop(now) {
      var dt = Math.min(0.05, (now - lastT) / 1000);
      lastT = now;
      frame(dt, now / 1000);
      raf = requestAnimationFrame(loop);
    }
    function start() { if (raf == null) { lastT = performance.now(); raf = requestAnimationFrame(loop); } }
    function stop() { if (raf != null) { cancelAnimationFrame(raf); raf = null; } }

    resize();
    window.addEventListener('resize', resize);

    if (still) { frame(0, 0); return; }
    new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }, { threshold: 0 }).observe(canvas);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  });
})();
